import * as Yup from "yup";
import form from "layouts/pages/account/company/components/Settings/schemas/form";
import { addPhoneValidationToYup } from "helpers/common";

const {
  formField: {
    companyName,
    emailAddress,
    addressLine1,
    phoneNumber,
    country,
    city,
    state,
    zipcode,
  },
} = form;

addPhoneValidationToYup(Yup);

const validations = Yup.object().shape({
  [companyName.name]: Yup.string().required(companyName.errorMsg),
  [emailAddress.name]: Yup.string().email(emailAddress.invalidMsg).required(emailAddress.errorMsg),
  [addressLine1.name]: Yup.string().required(addressLine1.errorMsg),
  [phoneNumber.name]: Yup.string().phone().required(phoneNumber.errorMsg),
  // .matches(/^\+(?:[0-9]●?){6,14}[0-9]$/, phoneNumber.invalidMsg)
  // .required(phoneNumber.errorMsg),
  // [country.name]: Yup.string()
  //   .required(country.errorMsg)
  //   .test("capitalized", "Country must start with a capital letter", (value) =>
  //     /^[A-Z]/.test(value)
  //   ),
  [country.name]: Yup.string()
    .required(country.errorMsg)
    .test("capitalized", "Country must start with a capital letter", (value) =>
      /^[A-Z]/.test(value)
    ),
  [city.name]: Yup.string()
    .required(city.errorMsg)
    .test("capitalized", "City must start with a capital letter", (value) => /^[A-Z]/.test(value)),
  [state.name]: Yup.string()
    .required(state.errorMsg)
    .test("capitalized", "State must start with a capital letter", (value) => /^[A-Z]/.test(value)),
  [zipcode.name]: Yup.string().required(zipcode.errorMsg),
});

export default validations;
